import Debugger from 'utils/debugger';
import { loadingActions } from 'modules/loading';
import { GA_ERROR_ACTIONS, GA_EVENTS } from 'constants/gaEvents';
import { sendGaEvent } from 'utils/sendGaEvent';
import ClientsApi from './repository';
import { clientsActions } from '.';

export const getAddressByPostalCode = (postalCode) => async (dispatch) => {
  dispatch(loadingActions.show());
  try {
    const response = await ClientsApi.getColonies(postalCode);
    const address = {
      states: [],
      cities: [],
    };
    if (response?.obj_data?.IdEstado) {
      address.states = [{
        label: response.obj_data.Estado,
        value: response.obj_data.IdEstado,
      }];
    }
    if (response?.obj_data?.Municipios?.length) {
      response.obj_data.Municipios?.forEach((municipality) => {
        const city = {
          label: municipality.Municipio,
          value: municipality.IdMunicipio,
          colonies: municipality.Colonias?.map((colony) => ({
            label: colony.Colonia,
            value: colony.IdColonia,
          })).sort((a, b) => a.label.localeCompare(b.label)),
        };
        address.cities.push(city);
      });
    }
    dispatch(loadingActions.hide());
    return address;
  } catch (error) {
    dispatch(loadingActions.hide());
    Debugger.error(error);
    return false;
  }
};

export const getCollections = () => async (dispatch) => {
  dispatch(clientsActions.initCollections());
  return ClientsApi.getCollections()
    .then((response) => {
      const data = {
        jobs: [],
        referrals: [],
        educationLevels: [],
      };
      (response?.obj_data || []).forEach((collection) => {
        const values = (collection?.valores || []).map((item) => ({
          label: item.Descripcion || item.id,
          value: item.id || item.Clave,
        }));
        switch (collection.nombre) {
          case 'CATALOGO OCUPACION':
            data.jobs = values
              .filter((item) => item.value.startsWith('M'))
              .sort((a, b) => a.label.localeCompare(b.label));
            break;
          case 'COMO SE ENTERO':
            data.referrals = values.map((item) => ({
              label: item.label.replace(/^[A-Z]\s-/g, '').trim(),
              value: item.value,
            })).sort((a, b) => a.label.localeCompare(b.label));
            break;
          case 'NIVEL DE ESTUDIOS':
            data.educationLevels = values;
            break;
          default:
            break;
        }
      });
      dispatch(clientsActions.successCollections(data));
      return true;
    })
    .catch((error) => {
      sendGaEvent({
        ...GA_EVENTS.ERROR,
        action: GA_ERROR_ACTIONS.COLLECTIONS_ERROR,
      });
      dispatch(clientsActions.errorCollections(error?.message || error));
      return false;
    });
};
